import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const LegacySettingsRedirect = ({ tab = "business", section = "" }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  if (!params.has("tab")) params.set("tab", tab);
  const hash = location.hash || (section ? `#${section}` : "");
  return (
    <Navigate
      replace
      to={`/pro/settings?${params.toString()}${hash}`}
      state={location.state}
    />
  );
};

export default LegacySettingsRedirect;
